<template>
  <lennoc-search-select
    :id="id"
    label="Land"
    :disabled="disabled"
    :items="countries"
    v-model="selectedCountry"
    :validationText="getUiString(['validatorMessages', 'nonumber'])">
    <slot />
  </lennoc-search-select>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CountrySelect',
  props: {
    id: {
      type: String,
      required: true,
      default () {
        return ''
      }
    },
    value: {
      type: String,
      required: false,
      default () {
        return 'NL'
      }
    },
    disabled: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    }
  },
  mounted () {
    if (this.value) {
      this.$emit('input', this.value)
    }
  },
  computed: {
    ...mapGetters({
      countries: 'getCountries',
      getUiString: 'uistrings/getUiString'
    }),
    selectedCountry: {
      get () {
        const selCountry = this.countries.filter(el => el.Code === this.value)
        return selCountry[0] || {}
      },
      set (newValue) {
        if (newValue) {
          this.$emit('input', newValue.Code)
        }
      }
    }
  }
}
</script>
